import type React from "react";

import CreditCardGateCustom from "./CreditCardGateCustom";

const CreditCardGateWrapper = ({ children }: { children: React.ReactNode }) => {
  return <CreditCardGateCustom>{children}</CreditCardGateCustom>;
};

CreditCardGateWrapper.displayName = "CreditCardGate";

export default CreditCardGateWrapper;
